import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMapMarkerAlt, faSearch, faTrash, faTruck } from "@fortawesome/free-solid-svg-icons";

export default function AgriLinkWholesale() {
  const [pinCode, setPinCode] = useState("");
  const [neighbourhood, setNeighbourhood] = useState("");
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [basketPrepared, setBasketPrepared] = useState(false);
  const [basketItems, setBasketItems] = useState([]);
  const [cart, setCart] = useState([]);
  const [showOrderForm, setShowOrderForm] = useState(false);
  const [orderDetails, setOrderDetails] = useState({ name: "", address: "", pin: "", mobile: "", email: "" });
  const [orderPlaced, setOrderPlaced] = useState(false);

  const categories = [
    { name: "Vegetables", img: "🥦" },
    { name: "Fruits", img: "🍎" },
    { name: "Spices", img: "🌶️" },
    { name: "Dairy", img: "🥛" },
    { name: "Poultry", img: "🐓" },
    { name: "Fish", img: "🐟" },
  ];

  const dummyItems = {
    Vegetables: [
      { name: "Tomato", unit: "kg", marketPrice: 40, wholesalePrice: 35, img: "https://via.placeholder.com/80?text=Tomato" },
      { name: "Potato", unit: "kg", marketPrice: 30, wholesalePrice: 25, img: "https://via.placeholder.com/80?text=Potato" },
      { name: "Spinach", unit: "kg", marketPrice: 20, wholesalePrice: 18, img: "https://via.placeholder.com/80?text=Spinach" },
    ],
    Fruits: [
      { name: "Apple", unit: "kg", marketPrice: 120, wholesalePrice: 100, img: "https://via.placeholder.com/80?text=Apple" },
      { name: "Banana", unit: "dozen", marketPrice: 50, wholesalePrice: 40, img: "https://via.placeholder.com/80?text=Banana" },
      { name: "Mango", unit: "kg", marketPrice: 150, wholesalePrice: 130, img: "https://via.placeholder.com/80?text=Mango" },
    ],
    Spices: [
      { name: "Turmeric Powder", unit: "kg", marketPrice: 200, wholesalePrice: 180, img: "https://via.placeholder.com/80?text=Turmeric" },
      { name: "Chili Powder", unit: "kg", marketPrice: 150, wholesalePrice: 120, img: "https://via.placeholder.com/80?text=Chili" },
    ],
    Dairy: [
      { name: "Milk", unit: "liter", marketPrice: 50, wholesalePrice: 45, img: "https://via.placeholder.com/80?text=Milk" },
      { name: "Curd", unit: "kg", marketPrice: 40, wholesalePrice: 35, img: "https://via.placeholder.com/80?text=Curd" },
    ],
    Poultry: [
      { name: "Chicken", unit: "kg", marketPrice: 200, wholesalePrice: 180, img: "https://via.placeholder.com/80?text=Chicken" },
      { name: "Eggs", unit: "dozen", marketPrice: 60, wholesalePrice: 50, img: "https://via.placeholder.com/80?text=Eggs" },
    ],
    Fish: [
      { name: "Rohu", unit: "kg", marketPrice: 250, wholesalePrice: 220, img: "https://via.placeholder.com/80?text=Rohu" },
      { name: "Pomfret", unit: "kg", marketPrice: 400, wholesalePrice: 350, img: "https://via.placeholder.com/80?text=Pomfret" },
    ],
  };

  const wholesaleOffers = [
    { name: "Tomato", minQty: 50, newPrice: 30, unit: "kg", msg: "Buy 50+ kg Tomato @ ₹30/kg" },
    { name: "Potato", minQty: 100, newPrice: 20, unit: "kg", msg: "Buy 100+ kg Potato @ ₹20/kg" },
    { name: "Apple", minQty: 20, newPrice: 90, unit: "kg", msg: "Buy 20+ kg Apple @ ₹90/kg" },
    { name: "Milk", minQty: 50, newPrice: 40, unit: "liter", msg: "Buy 50+ liters Milk @ ₹40/liter" },
    { name: "Eggs", minQty: 200, newPrice: 4, unit: "egg", msg: "Buy 200+ Eggs @ ₹4/egg" },
  ];

  const handlePrepareBasket = () => {
    if (!selectedCategory) return alert("Select a category first!");
    if (!pinCode.trim() || !neighbourhood.trim()) return alert("Enter PIN Code and Neighbourhood!");
    setBasketItems(dummyItems[selectedCategory] || []);
    setBasketPrepared(true);
    setCart([]);
  };

  const handleAddToCart = (item) => {
    const existing = cart.find((c) => c.name === item.name);
    if (existing) {
      setCart(cart.map(c => c.name === item.name ? { ...c, qty: c.qty + 1 } : c));
    } else {
      setCart([...cart, { ...item, qty: 1 }]);
    }
  };

  const handleQtyChange = (itemName, delta) => {
    setCart(cart.map(c => {
      if (c.name === itemName) {
        const newQty = c.qty + delta;
        if (newQty <= 0) return null;
        return { ...c, qty: newQty };
      }
      return c;
    }).filter(Boolean));
  };

  const handleRemoveItem = (itemName) => setCart(cart.filter(c => c.name !== itemName));

  const getPrice = (item) => {
    const offer = wholesaleOffers.find(o => o.name === item.name && item.qty >= o.minQty);
    return offer ? offer.newPrice : item.wholesalePrice;
  };

  const handlePlaceOrder = () => {
    if (cart.length === 0) return alert("Add at least one item to cart!");
    setShowOrderForm(true);
  };

  const handleSubmitOrder = () => {
    const { name, address, pin, mobile, email } = orderDetails;
    if (!name || !address || !pin || !mobile || !email) return alert("Fill all order details!");
    setOrderPlaced(true);
    setShowOrderForm(false);
  };

  return (
    <div className="min-h-screen bg-black flex flex-col">
      {/* Header */}
      <header className="bg-green-700 p-4 text-white flex flex-col md:flex-row md:items-center md:justify-between shadow-md">
        <h1 className="text-m lg:text-xl font-bold mb-2 md:mb-0">AgriLink Wholesale: Bulk Orders for Farmers, Retailers & Markets</h1>
      </header>

      {/* Search Bar */}
      <div className="flex flex-row justify-between p-4 bg-black broder border-green-500 shadow-sm">
        <div className="flex items-start space-x-2 text-white">
          <FontAwesomeIcon className="mt-2" icon={faMapMarkerAlt} />
          <input
            type="text"
            value={pinCode}
            onChange={(e) => setPinCode(e.target.value)}
            placeholder="Enter PIN Code"
            className="px-2 py-1 rounded text-black w-40 md:w-40"
          />
        </div>
        <div className="flex w-full items-start bg-black border border-green-500 p-2 rounded-lg">
          <FontAwesomeIcon icon={faSearch} className="text-green-600" />
          <input
            type="text"
            value={neighbourhood}
            onChange={(e) => setNeighbourhood(e.target.value)}
            placeholder="Search neighbourhood or product"
            className="ml-2 bg-transparent outline-none flex-1"
          />
        </div>
      </div>

      {/* Categories Grid */}
      <div className="p-4 grid grid-cols-3 sm:grid-cols-7 gap-4">
        {categories.map((cat) => (
          <div
            key={cat.name}
            onClick={() => setSelectedCategory(cat.name)}
            className={`flex flex-col items-center bg-white rounded-xl shadow p-4 cursor-pointer hover:scale-105 transition transform ${
              selectedCategory === cat.name ? "border-2 border-green-700" : ""
            }`}
          >
            <div className="text-4xl mb-2">{cat.img}</div>
            <span className="text-sm font-medium text-center">{cat.name}</span>
          </div>
        ))}
      </div>

      {/* Prepare Basket Button */}
      <div className="p-4">
        <button
          onClick={handlePrepareBasket}
          className="w-56 bg-green-600 border border-green-500 text-white py-2 rounded-lg hover:bg-green-800 flex items-center justify-center space-x-2"
        >
          Prepare Wholesale Basket
        </button>
      </div>

      {/* Basket Items */}
      {basketPrepared && (
        <>
          <div className="p-4 bg-black border border-green-500 text-white rounded shadow mb-4">
            <h3 className="text-yellow-200 text-lg lg:text-xl font-bold">📦 Wholesale Offers 📦</h3>
            <ul className="list-disc pl-5">
              {wholesaleOffers.map((offer) => (
                <li key={offer.name}>{offer.msg}</li>
              ))}
            </ul>
          </div>

          <div className="p-4 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4">
            {basketItems.map((item) => (
              <div key={item.name} className="bg-black text-white border border-green-500 p-4 rounded shadow flex flex-col items-center">
                <img src={item.img} alt={item.name} className="w-20 h-20 object-cover mb-2 rounded" />
                <span className="font-medium text-white">{item.name} ({item.unit})</span>
                <span className="line-through text-sm text-white">₹{item.marketPrice}/{item.unit}</span>
                <span className="text-white font-bold">₹{item.wholesalePrice}/{item.unit}</span>
                <button
                  onClick={() => handleAddToCart(item)}
                  className="mt-2 w-24  bg-black border border-green-500 text-white py-1 px-3 rounded hover:bg-green-700"
                >
                  Add
                </button>
              </div>
            ))}
          </div>
        </>
      )}

      {/* Cart & Place Order */}
      {basketPrepared && (
        <div className="p-4">
          <h3 className="text-yellow-200 text-lg lg:text-xl font-bold mb-2">Cart</h3>
          {cart.length === 0 ? (
            <p>No items added yet.</p>
          ) : (
            <div className="space-y-2">
              {cart.map((c) => (
                <div key={c.name} className="flex justify-between bg-black text-white border border-green-500 p-2 rounded shadow items-center">
                  <div className="flex items-center gap-2">
                    <img src={c.img} alt={c.name} className="w-10 h-10 object-cover rounded" />
                    <span>{c.name} ({c.unit})</span>
                  </div>
                  <div className="flex items-center gap-2">
                    <button
                      onClick={() => handleQtyChange(c.name, -1)}
                      className="bg-green-700 text-white px-2 w-8 rounded hover:bg-green-800"
                    >
                      -
                    </button>
                    <span>{c.qty}</span>
                    <button
                      onClick={() => handleQtyChange(c.name, +1)}
                      className="bg-blue-700 text-white px-2 w-8 rounded hover:bg-green-800"
                    >
                      +
                    </button>
                    <span>₹{getPrice(c) * c.qty}</span>
                    <button
                      onClick={() => handleRemoveItem(c.name)}
                      className="bg-red-600 text-white px-2 w-8 rounded hover:bg-red-700"
                    >
                      <FontAwesomeIcon icon={faTrash}/>
                    </button>
                  </div>
                </div>
              ))}
            </div>
          )}
          <button
            onClick={handlePlaceOrder}
            className="mt-4 w-full bg-green-600 border border-green-500 text-white py-2 rounded-lg flex items-center justify-center space-x-2 hover:bg-green-800"
          >
            <FontAwesomeIcon icon={faTruck} />
            <span>Place Wholesale Order</span>
          </button>
        </div>
      )}

      {/* Order Form */}
      {showOrderForm && (
        <div className="p-4 bg-black border border-green-500 text-white  shadow rounded m-4">
          <h3 className="font-bold mb-2">Enter Delivery Details</h3>
          <div className="flex flex-col py-2 px-2 gap-2">
            {"name address pin mobile email".split(" ").map((field) => (
              <input
                key={field}
                type="text"
                placeholder={field.charAt(0).toUpperCase() + field.slice(1)}
                value={orderDetails[field]}
                onChange={e => setOrderDetails({ ...orderDetails, [field]: e.target.value })}
                className="p-2 border rounded"
              />
            ))}
          </div>
          <button
            onClick={handleSubmitOrder}
            className="mt-4 w-64 bg-green-600 border border-green-500 text-white py-2 rounded hover:bg-green-800"
          >
            Confirm Wholesale Order
          </button>
        </div>
      )}

      {/* Invoice */}
      {orderPlaced && (
        <div className="p-4 bg-black text-white border border-green-500 shadow rounded m-4">
          <h3 className="text-yellow-200 text-xl font-bold mb-2">Wholesale Order Placed Successfully!</h3>
          <h3 className="text-white font-bold mb-2">Delivery scheduled as per logistics.</h3>
          <p>Invoice:</p>
          <ul className="list-disc pl-5">
            {cart.map((c) => (
              <li key={c.name}>{c.name} ({c.unit}) x {c.qty} = ₹{getPrice(c) * c.qty}</li>
            ))}
          </ul>
          <p className="font-bold">Total: ₹{cart.reduce((a, b) => a + getPrice(b) * b.qty, 0)}</p>
        </div>
      )}

      {/* Footer */}
      <footer className="mt-auto bg-green-800 text-white text-center p-4 text-sm">
        © 2025 AgriLink Wholesale by Think5Whys
      </footer>
    </div>
  );
}